import React, { Component } from 'react';
import '../login/Login.css';
import './../home/Home.css';
import logoimg from '../../assets/logo.svg';
import '../../assets/sprite-icon.svg';
import favicon from '../../assets/favicon.ico';


//pearson ui
import { Button, TextInput, RadioCheckGroup, Icon, Footer } from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import configJson from '../../_helpers/config.json';
const basePath= configJson["CommonConstants"]["Base_path"]
export default class Instruction extends Component {
  
    render() {
        const FooterLink = [{ text: 'Terms of Use', href: 'https://register.pearsoncmg.com/reg/include/license2.jsp' }, { text: ' Privacy Policy', href: 'https://register.pearsoncmg.com/w3c/privacy.htm' }];
        return (

            <div className="login-section">
                {/* Header Section Start  */}
                <header className="pe-fixed-header">
                    <div className="pe-header-lt">
                        <div className="logo">
                            <div className='pe_logo_name'>
                                <img src={favicon} alt="Pearson Favicon" width="40" className='pe_mobile_logo' />
                                <img src={logoimg} alt="Pearson Logo" width="130" className='pe_desktop_logo' />
                            </div>
                            <div className="pe_logo_desc"> SEARCHABLE <br></br> VIDEO COLLECTION </div>
                            <div className="clear"></div>
                        </div>
                    </div>
                    <div className="pe-header-rt">
                        <div className="pe-v-header-rt-sec">
                            <ul>
                                <li >
                                    {/* <div className="pe-help-icon">
                                        <PearsonDrawer />
                                    </div> */}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="clear"></div>
                </header>

                {/* Change Password Form Area Start  */}
                <div className="pe-v-login-form instruction_page">
                    <h1 className="title">Thanks for using Pearson Searchable Video Collection. <div className="inner_text">Please close this window</div></h1>
                </div>
                {/* Change Password Form Area End  */}

                {/* Footer Area Start */}
                <Footer links={FooterLink} anchorTarget="blank" />
                {/* Footer Area End */}

            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/instruction/instruction.js